var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "IframeModal" } }, [
    _c("div", { staticClass: "bg" }),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("iframe", { attrs: { src: _vm.iframeSrc, frameborder: "0" } }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }